import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Orange_Btn.css";

const Orange_Btn = ({ btnText, onClick, className }) => {
  return (
    <section className={`Orange_Btn_holder ${className || ""}`}>
      <Button className="Orange_Btn" onClick={onClick}>
        {btnText}
      </Button>
    </section>
  );
};

export default Orange_Btn;
